import * as _ from 'lodash'
import {ConstraintBasedOptimizerBO} from "./ConstraintBasedOptimizerBO";
import {WB_CBOConstraintRow} from "../PA.Core/PAdbSchemaRows";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";


export class ConstraintBasedOptimizerBOValidation {
    static async Validation(aBO: ConstraintBasedOptimizerBO): Promise<void> {
        await ConstraintBasedOptimizerBOValidation.ValidateInputFields(aBO)
    }


    static async ValidateInputFields(aBO: ConstraintBasedOptimizerBO): Promise<void> {
        let minMaxValue = false;

        _.forEach(aBO.drWB_CBO.WB_CBOConstraintRows, (contRow: WB_CBOConstraintRow) => {
            console.log(contRow);
            console.log(contRow.cif.MAX_VALUE);
            console.log(contRow.cif.MIN_VALUE);
            if (_.gt(_.toNumber(contRow.cif.MIN_VALUE), _.toNumber(contRow.cif.MAX_VALUE)))
                minMaxValue = true;

        });

        if (minMaxValue) {
            ErrorMessage_restate(aBO.ValidateMessageProvider,
                true,
                "maxMinValue",
                "Max value must be greater than Min value");
        }
    }


}